import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { EntityType, MaintenanceDto } from "@/core/api/generated/v1";

interface Props {
  maintenance: MaintenanceDto;
}

export default function CommentsTabContent({ maintenance }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <EntityCommentsChat
          entityId={maintenance.id!}
          entityType={EntityType.Maintenance}
          entity={maintenance}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
